// The deal flow's vocabulary (TX-US-0043): the Incoterms with what each says. Read once per
// screen; it is fixed in code on the server and changes only with a release.

import { useEffect, useState } from 'react';

import { getDealVocabulary } from '../api.js';

const EMPTY = Object.freeze({ incoterms: [] });

// `enabled` is false where the flow is off, and then nothing is asked: the endpoint is mounted
// only with the flow on. A failure is the screen's to show; the Incoterm select is empty until
// then, and the API still refuses a deal without one.
export function useDealVocabulary(enabled) {
  const [vocabulary, setVocabulary] = useState(EMPTY);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    getDealVocabulary()
      .then(({ incoterms }) => {
        if (!cancelled) setVocabulary({ incoterms });
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { ...vocabulary, error };
}
